import script from "./UnauthorizedView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnauthorizedView.vue?vue&type=script&setup=true&lang=ts"

import "./UnauthorizedView.vue?vue&type=style&index=0&id=a57d2e94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a57d2e94"]])

export default __exports__